/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_CreateInputs */

const en_nav_create = /** @type {(inputs: Nav_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const es_nav_create = /** @type {(inputs: Nav_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Nav_CreateInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
const nav_create = /** @type {((inputs?: Nav_CreateInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_CreateInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_create(inputs)
	return en_nav_create(inputs)
});
export { nav_create as "nav.create" }